module.exports = __webpack_public_path__ + "img/img-quick-05.2e5cb530.png";